import type { ReactNode } from 'react';
import classNames from 'classnames';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { CARD_BORDER_RADIUS } from '@shared/constants/card.constants';

const useStyles = makeStyles({
  canvas: {
    overflow: 'hidden',
    backgroundColor: tokens.colorNeutralBackground3,
    borderTopLeftRadius: CARD_BORDER_RADIUS,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderLeft: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
  },
});

type TProps = {
  nav: ReactNode;
  children: ReactNode;
  // Keeps centred content from shifting sideways when the scrollbar appears.
  stableScrollbarGutter?: boolean;
  // Frames the content as a rounded surface inside the white app shell.
  canvas?: boolean;
};

// The absolute pane keeps the page scrollbar inside the content area, beside the nav drawer.
export const ListPageLayout = ({ nav, children, stableScrollbarGutter = false, canvas = false }: TProps) => {
  const classes = useStyles();

  return (
    <div className="flex flex-1 h-full">
      {nav}
      <div className={mergeClasses('grow h-full w-full relative', canvas && classes.canvas)}>
        <div
          className={classNames('absolute top-0 left-0 w-full h-full overflow-y-auto', {
            '[scrollbar-gutter:stable]': stableScrollbarGutter,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
